import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AssessmentTabs: React.FC = () => {
  const location = useLocation();
  const isPreAssessment = location.pathname.startsWith('/onboarding');
  const isAssessments = location.pathname.startsWith('/assessments');

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-6" aria-label="Assessment sections">
        <Link
          to="/onboarding"
          className={`whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-semibold ${
            isPreAssessment
              ? 'border-primary-500 text-primary-600'
              : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
          }`}
        >
          Pre-Assessment
        </Link>
        <Link
          to="/assessments"
          className={`whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-semibold ${
            isAssessments
              ? 'border-primary-500 text-primary-600'
              : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
          }`}
        >
          Assessments
        </Link>
      </nav>
    </div>
  );
};

export default AssessmentTabs;
